import { render, staticRenderFns } from "./StatementSettings.vue?vue&type=template&id=bd0204bc&"
import script from "./StatementSettings.vue?vue&type=script&lang=js&"
export * from "./StatementSettings.vue?vue&type=script&lang=js&"
import style0 from "./StatementSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports